import { Formik, Form } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { Button, FormGroup, Input, Label } from "reactstrap";
import { columns, fixedCol } from "../../Members/columns";
import { getProfileVendorRequest } from "../../../../redux/admin/members/action";
import { vendorAccountColumns } from "../../../../constant/vendorAccountColumns";

function VendorUserColumns(props) {
  const {
    vendorId,
    savedColumns,
    setVendorUserColumns,
    onModalDismiss,
    vendorProfile,
    getVendors,
  } = props;

  const [selectedColumns, setSelectedColumns] = useState(savedColumns);

  useEffect(() => {
    setSelectedColumns(savedColumns);
  }, [savedColumns]);

  /* the account number columns are whatever vendorProfile lists - the same
     source the member view builds its "Vendors Account Number" block from */
  useEffect(() => {
    getVendors();
  }, []);

  const accountColumns = useMemo(
    () => vendorAccountColumns(vendorProfile),
    [vendorProfile]
  );

  const selectableColumns = useMemo(
    () => [...columns.filter((col) => col.label), ...accountColumns],
    [accountColumns]
  );

  const handleSelectedColumns = (event) => {
    const { id, checked } = event.target;
    const columnData = selectableColumns.find((col) => col.field === id);
    if (checked) {
      if (columnData && !selectedColumns.some((col) => col.field === id)) {
        setSelectedColumns((prevSelected) => [...prevSelected, columnData]);
      }
    } else {
      setSelectedColumns((prevSelected) =>
        prevSelected.filter((col) => col.field !== id)
      );
    }
  };

  const handleSubmit = async () => {
    setVendorUserColumns({
      vendorId: vendorId,
      columnsSelected: selectedColumns,
    });
    onModalDismiss();
  };

  const isChecked = (field) =>
    selectedColumns.some((column) => column.field === field);

  const checkboxOptions = columns
    .filter((col) => col.label)
    .map((col) => ({
      id: col.field,
      label: col.label,
    }));

  return (
    <Formik initialValues={{}} onSubmit={handleSubmit} enableReinitialize>
      {({ isSubmitting }) => (
        <Form className="form-horizontal column-configuration">
          <div className="column-config-scrollable">
            <div className="checkbox-column">
              {fixedCol.map((option) => (
                <FormGroup key={option.field}>
                  <Input type="checkbox" id={option.field} disabled checked />
                  <Label for={option.field}>{option.label}</Label>
                </FormGroup>
              ))}
              {checkboxOptions.map((option) => (
                <FormGroup key={option.id}>
                  <Input
                    type="checkbox"
                    id={option.id}
                    onChange={handleSelectedColumns}
                    checked={isChecked(option.id)}
                  />
                  <Label for={option.id}>{option.label}</Label>
                </FormGroup>
              ))}
            </div>
            {accountColumns.length > 0 && (
              <>
                <h6 className="column-group-title">Vendors Account Number</h6>
                <div className="checkbox-column">
                  {accountColumns.map((option) => (
                    <FormGroup key={option.field}>
                      <Input
                        type="checkbox"
                        id={option.field}
                        onChange={handleSelectedColumns}
                        checked={isChecked(option.field)}
                      />
                      <Label for={option.field}>{option.label}</Label>
                    </FormGroup>
                  ))}
                </div>
              </>
            )}
          </div>
          <div className="btn-box">
            <Button
              color="primary"
              title="vendor user columns"
              type="submit"
              disabled={isSubmitting}
            >
              {savedColumns.length > 0 ? "Update" : "Submit"}
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
}

const mapStateToProps = ({ Members }) => {
  return {
    vendorProfile:
      Members?.proVendor?.list?.length > 0 ? Members.proVendor.list : [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getVendors: () => dispatch(getProfileVendorRequest()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VendorUserColumns);
